"use client";

import { useEffect } from "react";

import { setSearchTerm } from "../types/searchTerm.helper";

export function SearchTermCapture() {
  useEffect(() => {
    const captureSearchInput = () => {
      const input = document.querySelector<HTMLInputElement>('input[name="q"]');
      if (input?.value) {
        setSearchTerm(input.value.trim());
        input.blur();
      }
    };

    const handleSubmit = (e: Event) => {
      const form = e.target as HTMLFormElement;
      if (form.querySelector?.('input[name="q"]')) captureSearchInput();
    };

    const handleClick = (e: MouseEvent) => {
      const link = (e.target as HTMLElement).closest?.(
        '[data-testid="search-list"] a',
      );
      if (link) captureSearchInput();
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      const input = document.querySelector<HTMLInputElement>('input[name="q"]');
      if (document.activeElement === input) input?.blur();
    };

    document.addEventListener("submit", handleSubmit, true);
    document.addEventListener("mousedown", handleClick, true);
    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("submit", handleSubmit, true);
      document.removeEventListener("mousedown", handleClick, true);
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, []);

  return null;
}
